var module; // LICENSE_CODE ZON

'use strict';
/*jslint node:true, browser:true*/


var is_node = !!(typeof module == 'object' && module.exports);
define([], function () {
  var E = {};

  function add(id, dname, opt) {
    E[id] = Object.assign({
      id: id,
      dname: dname
    }, opt);
  }

  add('bluesnap', 'BlueSnap', {
    pcode: 24
  });
  add('safecharge', 'SafeCharge', {
    pcode: 23,
    pcode_scd: 20
  });
  add('manual', 'Manual');
  return E;
});